import { buildRouteHead } from "@/lib/seo/routeHead";
import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/zh-cn/our-offices")({
  head: () => buildRouteHead("/zh-cn/our-offices", { noIndex: true }),
  beforeLoad: () => {
    throw redirect({ to: "/zh-cn/contact", replace: true });
  },
});
